module.exports = __webpack_public_path__ + "img/acaki17.01f29755.jpg";